<template>
    <div class="z-10">
        <PageComponent 
            :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
            :showAddButton="showAddButton"
            :searchFilters="searchFilters"
            @searchPage="searchEmployees"
            @resetFilters="resetFilters"
            :dropdownOptions="dropdownOptions"
            @handleDynamicOption="handleDynamicOption"
            @removeItem="removeItem"
            @removeSelectedItems="removeItem"
            @printList="printPayrollDetails"
            @printExcel="printPayrollDetailsExcel"
            v-model:printModalVisible="printModalVisible"
            :printTitle="printTitle"
            :pdfUrl="pdfUrl"
            :rightsModule="rightsModule"
            :columns="tableColumns"
            :rows="employeesList"
            :actions="actions"
            :showTotals="showTotals"
            :idField="idField"
            @handleSelectionChange="handleSelectionChange"
            @handleActionClick="handleActionClick"
            :count="propCount"
            :currentPage="currentPage"
            :result="propArrLen"
            @loadPrev="loadPrev"
            @loadNext="loadNext"
            @firstPage="firstPage"
            @lastPage="lastPage"
            :showNextBtn="showNextBtn"
            :showPreviousBtn="showPreviousBtn"
            :selectedValue="selectedValue"
            @selectSearchQuantity="selectSearchQuantity"
        />
        <MovableModal v-model:visible="appModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader" @closeModal="closeModal"
        >
            <DynamicForm 
                :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" :saveButtonLabel="'Print'"
                :displayButtons="displayButtons" @handleSubmit="printPayrollDetails" @handleReset="handleReset"
            />
        </MovableModal>
        <PrintModal v-model:visible="printModalVisible1" :title="printTitle" >
            <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="100%" type="application/pdf" style="border: none;"></iframe>
        </PrintModal>
    </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted, onBeforeMount} from 'vue';
import PageComponent from '@/components/PageComponent.vue'
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import DynamicForm from '../NewDynamicForm.vue';
import MovableModal from '@/components/MovableModal.vue';
import SearchableDropdown from '@/components/SearchableDropdown.vue';
import Swal from 'sweetalert2';
import PrintModal from '@/components/PrintModal.vue';

export default{
    name: 'Payroll_Employees',
    components:{
        PageComponent,MovableModal,SearchableDropdown,PrintModal,DynamicForm
    },
    setup(){
        const store = useStore();
        const toast = useToast();
        const loader = ref('');
        const modal_loader = ref('none');
        const trans_modal_loader = ref('none');
        const idField = 'payroll_employee_id';
        const showAddButton = ref(false);
        const rightsModule = ref('HR');
        const submitButtonLabel = ref('Add');
        const selectedIds = ref([]);
        const employeesList = ref([]);
        const propResults = ref([]);
        const propArrLen = ref(0);
        const propCount = ref(0);
        const pageCount = ref(0);
        const selectedValue = ref(50);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const transTitle = ref('Transfer Unit');
        const title = ref('Print Payroll Details');
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const appModalVisible = ref(false);
        const transModalVisible = ref(false);
        const printModalVisible = ref(false);
        const printModalVisible1 = ref(false);
        const pdfUrl = ref(null);
        const printTitle = ref('Print Payslip');
        const dropdownWidth = ref("320px")
        const modal_top = ref('200px');
        const modal_left = ref('400px');
        const modal_width = ref('50vw');
        const showModal = ref(false);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Staff No", key:"staff_number"},
            {label: "Employee Name", key:"employee_name"},
            {label: "Basic Pay", key:"base_salary", type: "number", textColor: "black"},
            {label: "Allowances", key: "allowances", type: "number", textColor: "black"},
            {label: "Overtime", key: "overtime", type: "number", textColor: "black"},
            {label: "Benefits", key: "benefits", type: "number", textColor: "black"},
            {label: "Gross Pay", key:"gross_pay", type: "number", textColor: "black"},
            {label: "S.H.I.F", key:"shif_amount", type: "number", textColor: "black"},
            {label: "N.S.S.F", key:"nssf_amount", type: "number", textColor: "black"},
            {label: "A.H.L", key:"housing_levy_amount", type: "number", textColor: "black"},
            {label: "P.A.Y.E", key:"tax", type: "number", textColor: "black"},
            {label: "Advances", key:"salary_advances", type: "number", textColor: "black"},
            {label: "Loans", key:"company_loans", type: "number", textColor: "black"},
            {label: "Absent.", key:"absenteeism", type: "number", textColor: "black"},
            {label: "Other Ded.", key:"deductions", type: "number", textColor: "black"},
            {label: "Reimb.", key:"reimbursements", type: "number", textColor: "black"},
            {label: "Net Pay", key:"net_pay", type: "number", textColor: "black"},
        ])
        const showTotals = ref(true);
        const actions = ref([
            {name: 'email-payslip', icon: 'fa fa-envelope', title: 'Email Payslip', rightName: 'Sending HR Emails'},
            {name: 'print', icon: 'fa fa-print', title: 'Print Payslip', rightName: 'Print Payslip'},

        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const payrollID = computed(()=> store.state.Payrolls.payrollID);
        const payrollName = computed(()=> store.state.Payrolls.payrollName);
        const staff_number_search = ref('');
        const employee_name_search = ref('');
        const searchFilters = ref([
            {type:'text', placeholder:"Staff No...", value: staff_number_search, width:64,},
            {type:'text', placeholder:"Employee Name...", value: employee_name_search, width:64,},
        ]);

        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const showTransModalLoader = () =>{
            trans_modal_loader.value = "block";
        }
        const hideTransModalLoader = () =>{
            trans_modal_loader.value = "none";
        }
        const emailPaySlip = async(employeeID) =>{

            let formData = {
                employee: employeeID,
                company: companyID.value
            }
            Swal.fire({
            title: "Are you sure?",
            text: `Do you wish to Email Payslip?`,
            type: 'warning',
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: 'Yes Email Payslip!',
            cancelButtonText: 'Cancel!',
            customClass: {
                confirmButton: 'swal2-confirm-custom',
                cancelButton: 'swal2-cancel-custom',
            },
            showLoaderOnConfirm: true,
            }).then((result) => {
            if (result.value) {
                axios.post(`api/v1/email-employee-payslip/`,formData)
                .then((response)=>{
                if(response.data.msg == "Success"){
                    Swal.fire("Email Sent succesfully!", {
                        icon: "success",
                    }); 
                    searchEmployees();
                }else if(response.data.msg == "Failed"){
                    Swal.fire({
                        title: "Error Sending Pyslip",
                        icon: "warning",
                    });
                }                   
                })
                .catch((error)=>{
                    console.log(error.message);
                    Swal.fire({
                        title: error.message,
                        icon: "warning",
                    });
                })
            }else{
                Swal.fire(`Email has not been sent!`);
            }
            })     
        };
        const closeTransModal = () =>{
            transModalVisible.value = false;
            employeeID.value = null;
            hideTransModalLoader();
        };
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }

        const formFields = ref();
        const updateFormFields = () =>{
            formFields.value = [
                {  type: 'checkbox', label: 'Staff No', name: 'staff_number', value: true, selected: true, required: false},
                {  type: 'checkbox', label: 'Employee Name', name: 'employee_name', value: true, selected: true, required: false},
                {  type: 'checkbox', label: 'Basic Pay', name: 'basic_pay', value: true, selected: true, required: false},
                {  type:'checkbox', label:'Allowances', name:'allowances', value:'', required:false},
                {  type:'checkbox', label:'Non Cash Benefits', name:'benefits', value:'', required:false},
                {  type:'checkbox', label:'Overtime', name:'overtime', value:'', required:false},
                {  type: 'checkbox', label: 'Gross Pay', name: 'gross_pay', value: true, selected: true, required: false},
                {  type:'checkbox', label:'SHIF', name:'shif', value:'', required:false},
                {  type:'checkbox', label:'NSSF', name:'nssf', value:'', required:false},
                {  type:'checkbox', label:'Housing Levy', name:'housing_levy', value:'', required:false},  
                {  type:'checkbox', label:'PAYE', name:'tax', value:'', required:false},         
                {  type:'checkbox', label:'Absenteeism', name:'absenteeism', value:'', required:false},
                {  type:'checkbox', label:'Salary Advances', name:'salary_advance', value: true, selected: true, required: false}, 
                {  type:'checkbox', label:'Company Loans', name:'company_loans', value: true, selected: true, required: false},
                {  type:'checkbox', label:'Deductions', name:'deductions', value:'', required:false},
                {  type:'checkbox', label:'Reimbursements', name:'reimbursements', value:'', required:false},
                {  type:'checkbox', label:'Net Pay', name:'net_pay', value: true, selected: true, required:false}, 
                {required: false, value: false},
                {required: false, value: false},
            ]
        };
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
       
        const searchEmployees = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                staff_number: staff_number_search.value,
                employee_name: employee_name_search.value,
                payroll: payrollID.value,
                company: companyID.value,
                page_size: selectedValue.value
            } 
            axios
            .post(`api/v1/payroll-employees-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                employeesList.value = response.data.results;
                // store.commit('Terminated_Leases/LIST_TENANTS', employeesList.value)
                propResults.value = response.data;
                propArrLen.value = employeesList.value.length;
                propCount.value = propResults.value.count;
                pageCount.value = Math.ceil(propCount.value / selectedValue.value);
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchEmployees(selectedValue.value);
        };
        const resetFilters = () =>{
            currentPage.value = 1;
            selectedValue.value = 50;
            staff_number_search.value = "";
            employee_name_search.value = "";
            searchEmployees();
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchEmployees();
            // scrollToTop();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchEmployees();
            // scrollToTop(); 
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchEmployees();
            // scrollToTop();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchEmployees();
            // scrollToTop();
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if(action == 'email-payslip'){
                showLoader();
                const employeeID = [row['employee_id']];
                const payrollID = row['payroll_id'];
      
                let formData = {
                    employee: employeeID,
                    payroll: payrollID,
                    company: companyID.value
                }
                await axios.post('api/v1/employee-payslip-email/',formData).
                then((response)=>{
                    if(response.data.msg == "Success"){
                        toast.success("Email Sent!")
                    }else if(response.data.msg == "Missing Template"){
                        toast.error("Employee Payslip Template Not Set!")
                    }else{
                        toast.error(response.data.msg)
                    }
                })
                .catch((error)=>{
                    toast.error(error.message)
                })
                .finally(()=>{
                    hideLoader();
                })
            }else if(action == 'print'){
                const employeeID = row['employee_id'];
                showLoader();
                let formData = {
                    company: companyID.value,
                    employee: employeeID,
                    payroll: payrollID.value
                }
                axios
                .post("api/v1/print-employee-payslip-pdf/", formData, { responseType: 'blob' })
                    .then((response)=>{
                        if(response.status == 200){
                            const blob1 = new Blob([response.data], { type: 'application/pdf' });
                            const url = URL.createObjectURL(blob1);
                            pdfUrl.value = url;
                            printModalVisible1.value = true;
                        }
                    })
                .catch((error)=>{
                    toast.error(error.message);
                })
                .finally(()=>{
                    hideLoader();
                })
                
            }
        };
        const dropdownOptions = ref([
            {label: 'Print Detailed', action: 'print-detailed',icon: 'fa-print',colorClass: 'text-gray-700', rightName: 'Printing HR Reports'},
            {label: 'Email Employee Payslips', action: 'email-payslip', icon: 'fa-envelope', colorClass: 'text-indigo-500', rightName: 'Sending HR Emails'},

        ]);
        const handleDynamicOption = async(option) =>{           
            if(option == 'email-payslip'){
                showLoader();
                const employeeID = selectedIds.value;
      
                let formData = {
                    employee: employeeID,
                    company: companyID.value
                }
                await axios.post('api/v1/employee-payslip-email/',formData).
                then((response)=>{
                    if(response.data.msg == "Success"){
                        toast.success("Email Sent!")
                    }else if(response.data.msg == "Missing Template"){
                        toast.error("Employee Payslip Template Not Set!")
                    }else{
                        toast.error(response.data.msg)
                    }
                })
                .catch((error)=>{
                    toast.error(error.message)
                })
                .finally(()=>{
                    hideLoader();
                })
            }else if(option == 'print-detailed'){
                appModalVisible.value = true;
                updateFormFields();
                flex_basis.value = '1/4';
                flex_basis_percentage.value = '20';
            }
        };
        
        const printPayrollDetails = () =>{
            appModalVisible.value = false;
            showLoader();
            let formData = {
                staff_number: staff_number_search.value,
                employee_name: employee_name_search.value,
                payroll: payrollID.value,
                printData: formFields.value || [],
                company: companyID.value
            } 

            axios
            .post("api/v1/export-payroll-details-pdf/", formData, { responseType: 'blob' })
                .then((response)=>{
                    if(response.status == 200){
                        const blob1 = new Blob([response.data], { type: 'application/pdf' });
                        const url = URL.createObjectURL(blob1);
                        pdfUrl.value = url;
                        printModalVisible.value = true;
                    }
                })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        }
        const printPayrollDetailsExcel = () =>{
            showLoader();
            let formData = {
                staff_number: staff_number_search.value,
                employee_name: employee_name_search.value,
                payroll: payrollID.value,
                company: companyID.value
            } 

            axios
            .post("api/v1/export-payroll-details-excel/", formData, { responseType: 'blob' })
                .then((response)=>{
                    if(response.status == 200){
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        const fileName = `Payroll Details ${payrollName.value}.xlsx`;
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                    }
                })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        }
        onBeforeMount(()=>{
            searchEmployees();
            
        })
        return{
            searchEmployees,resetFilters, searchFilters, tableColumns, employeesList,dropdownWidth,showAddButton,printModalVisible1,
            currentPage,propResults, propArrLen, propCount, pageCount, showNextBtn, showPreviousBtn,printModalVisible,pdfUrl, printTitle,
            loadPrev, loadNext, firstPage, lastPage, idField, actions, handleActionClick,flex_basis,flex_basis_percentage,formFields,
            submitButtonLabel, showModal, showLoader, loader, hideLoader,showTotals,displayButtons,
            handleSelectionChange,rightsModule,printPayrollDetails,printPayrollDetailsExcel,selectSearchQuantity,selectedValue, dropdownOptions, handleDynamicOption,
            modal_left,modal_top,modal_width,trans_modal_loader,transModalVisible,transTitle,showTransModalLoader,hideTransModalLoader,closeTransModal,
            modal_loader,appModalVisible,title,showModalLoader,hideModalLoader
        }
    }
};
</script>